var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"w-100 h-100 flex-col items-center"},[_c('img',{staticStyle:{"width":"20%"},attrs:{"src":require("@/assets/empty.png")}}),_c('div',{staticClass:"mt20 font14 c-8F8E8E"},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }